/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiAuthorsIdMutationResponse, DeleteApiAuthorsIdPathParams, DeleteApiAuthorsId400, DeleteApiAuthorsId401, DeleteApiAuthorsId403, DeleteApiAuthorsId500 } from "../../types/DeleteApiAuthorsId.ts";
import { deleteApiAuthorsIdMutationResponseSchema } from "../../zod/AuthorSchemas/deleteApiAuthorsIdSchema.ts";

function getDeleteApiAuthorsIdUrl({ id }: { id: DeleteApiAuthorsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/authors/${id}` as const }  
  return res
}

/**
 * @summary Метод удаления автора по идентификатору.
 * {@link /api/authors/:Id}
 */
export async function deleteApiAuthorsId({ id }: { id: DeleteApiAuthorsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiAuthorsIdMutationResponse, ResponseErrorConfig<DeleteApiAuthorsId400 | DeleteApiAuthorsId401 | DeleteApiAuthorsId403 | DeleteApiAuthorsId500>, unknown>({ method : "DELETE", url : getDeleteApiAuthorsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiAuthorsIdMutationResponseSchema.parse(res.data)
}